import React from 'react';
import { BlockWrapper, defineBlock, useEditor, useInspectorControl, smartProps } from '@smartfire/js-block-engine';
import { EditableText, EditableImg } from '@smartfire/components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import { GuedelonButton } from '../bouton-guedelon/button';
import style from './block.module.scss';
import { ReactComponent as Arrow } from './fleche.svg';
import { useTranslation } from 'react-i18next';
import SlidesAdmin from './slidesAdmin';
import Slide from './slide';
import type { SlideType } from './slide';
const InspectorLazy = React.lazy(() => import('./Inspector'));

const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className={style.prevArrow} onClick={onClick}>
            <Arrow />
        </div>
    );
};
const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className={style.nextArrow} onClick={onClick}>
            <Arrow />
        </div>
    );
};

const settings = {
    arrows: true,
    infinite: true,
    autoplaySpeed: 6000,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
};
type IntroductionHomeProps = {
    slides: SlideType[];
    buttonLink?: string;
    buttonText?: string;
    image?: object;
    type?: boolean;
    file?: { url: string };
    external: boolean;
};
function Block({ slides, buttonLink, buttonText, image, type, file, external }: IntroductionHomeProps) {
    const { isEditing } = useEditor();
    useInspectorControl(InspectorLazy, []);
    const { t } = useTranslation();

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <div className={style.slides}>
                    <div className={style.slideHeader}>
                        <span>{t('Le saviez-vous ?')}</span>
                    </div>
                    {slides && (
                        <Slider className={style.slider} {...settings}>
                            {slides.map((slide, index) => (
                                <Slide key={`slide-${index}`} slide={slide} />
                            ))}
                        </Slider>
                    )}
                </div>
                <div className={style.right}>
                    <EditableText tagName="h2" placeholder="ajouter un titre" smartProp="title" />
                    <EditableText
                        tagName="p"
                        placeholder="ajouter un texte"
                        smartProp="text"
                        allowedFormats={['core/bold']}
                    />
                    {(isEditing || buttonText) && (
                        <GuedelonButton
                            external={external}
                            className={style.guedelonButton}
                            href={isEditing ? undefined : type ? file?.url : buttonLink}
                        >
                            <EditableText tagName="span" placeholder="ajouter un texte" smartProp="buttonText" />
                        </GuedelonButton>
                    )}
                    {(image || isEditing) && <EditableImg className={style.image} smartProp="image" />}
                </div>
                <div className={style.bottom}>
                    {(image || isEditing) && <EditableImg className={style.image} smartProp="image" />}
                </div>
            </div>
            {isEditing && (
                <>
                    <h2>Configuration des slides de texte</h2>
                    <SlidesAdmin slides={slides} />
                </>
            )}
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        slides: smartProps.array.withDefault([
            {
                title: '',
                text: '',
                link: '',
                picture: null,
            },
        ]),
        title: smartProps.string.withDefault(''),
        text: smartProps.string.withDefault(''),
        buttonLink: smartProps.string.withDefault(''),
        buttonText: smartProps.string.withDefault(''),
        file: smartProps.object.withDefault(null),
        external: smartProps.bool.withDefault(false),
        type: smartProps.bool.withDefault(false), //false: link - true: file
        image: smartProps.object.withDefault(null),
    },
    setup: {
        title: 'Introduction Home',
        icon: 'align-left',
    },
});
